
import bus from '@/javascript/bus'
import './index.less'
import Calendar from 'vux/src/components/calendar/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import elasticLayer from '@/components/lyx-components/elasticLayer/index.vue'
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Cpts020,
elasticLayer,
Calendar,
Toast,
goBack
},
data() {
return {
isWeixin: util.isWeiXin(),
minHeight: 0,
playData: '',
week: '',
historyData: [],
params: JSON.parse(sessionStorage.getItem('historyData')) ? JSON.parse(sessionStorage.getItem('historyData')) : {},
hotCity: [],
allCity: [],
cityPage: 0,
citySize: 6,
layerShow: false,
cityName: '请选择出发城市',
cityCode: '',//行程定制所用code
prompt: false,
cityEmpty: '出发城市不能为空',
modifyId: '',
cityList: [],
showbtn: false,
page: 0,
pageSize: 3,
recomList: [],  //推荐行程
authorData: [{
name: '習慣菰獨ルo',
headerImg: require('../../../../assets/headerImg-1.jpg')
}, {
name: '仰望天空╮天空依旧',
headerImg: require('../../../../assets/headerImg-2.jpg')
}, {
name: '℡昔作别旧梦',
headerImg: require('../../../../assets/headerImg-3.jpg')
}],
modifyWay: '',
defaultWay: false,
defaultText: '您的出发地在海晏外,出行方式默认为公共交通',
arrSet: [],
planStartDate: '',
afterDate: ''
}
},
watch: {

playData: function (val, oldVal) {
const weekArray = new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六")
this.playData = val
const a = new Date(val).getDay()
this.week = weekArray[a]
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
document.title = '行程定制'
/**
* 微信签名分享
*/
if (this.isWeixin) {
const shareData = typeof(shareData) === 'undefined' ? {
title: this.PAGE_TITLE + '行程定制',
desc: this.SHARE_TEXT,
imgUrl: this.STATIC_BASE_URL+'/images/share/share.jpg',
link: window.location.href
} : shareData;

this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)

})
}
this.getCity()
if (JSON.stringify(this.params) !== '{}' && this.params.travelId) {
this.modifyId = this.params.travelId
this.cityName = this.params.startCityName
this.cityCode = this.params.startCityCode
this.modifyWay = this.params.transportType
this.planStartDate = this.params.planStartDate
this.showbtn = true
} else if (this.params.endCityCode) {
this.cityName = this.params.startCityName
this.cityCode = this.params.startCityCode
}


this.$http.get('api/wtcp-recommend/public/travelPlan/app/page?isAsc=false&page=' + this.page + '&size=' + this.pageSize + '&sort=updated_time&status=2' + '&deptCode=-1').then((response) => {
const that = this
that.$set(that, 'recomList', response.data.data.records)
that.recomList.forEach((item) => {
const a = []
let images = []
const imgData = []
a.push({
totalDays: item.totalDays + '天',
totalCities: item.totalCities + '城市',
totalScenics: item.totalScenics + '景点',
totalLength: Math.floor(item.totalDistance / 1000) + '公里',
})
item.recommends = a
images = images.concat(item.titleImages.split(','))
let arr = that.randomArr(images.length)
let data = that.RandomNumBoth(arr, 0)
for (let i = 0; i < 3 && i < data.length; i++) {
imgData.push(images[data[i]])
}
item.titleImages = imgData
})
})

this.getDate()

const date = new Date();
const futureDate = new Date(date.getTime() + 24 * 60 * 60 * 1000 * 91); 
let y = futureDate.getFullYear()
let m = futureDate.getMonth() + 1
let d = futureDate.getDate()
this.afterDate = y + '-' + (m > 9 ? m : '0' + m) + '-' + (d > 9 ? d : '0' + d)
},
methods: {
getDate() {
const date = new Date();
if (this.planStartDate !== '' && date < (new Date(this.planStartDate.replace(/-/g, "\/")))) {
this.playData = this.planStartDate
} else {
const nextDate = new Date(date.getTime() + 24 * 60 * 60 * 1000); 
let x = nextDate.getFullYear()
let y = nextDate.getMonth() + 1
let z = nextDate.getDate()
const val = x + '-' + (y > 9 ? y : '0' + y) + '-' + (z > 9 ? z : '0' + z)
this.playData = val
}
},
chooseCity() {
this.layerShow = true
},
getCity() {

this.$http.get("api/wtcp-recommend/public/cityManagement/hot?page=" + this.cityPage + "&size=" + this.citySize).then((response) => {
this.$set(this, 'hotCity', response.data.data)
})

this.$http.get("api/wtcp-recommend/public/cityManagement").then((response) => {
this.$set(this, 'allCity', response.data.data)
})
},

nextStep() {
if (this.cityName == "请选择出发城市") {
this.prompt = true
} else {
this.params['startCityName'] = this.cityName
this.params['startCityCode'] = this.cityCode
this.params['endCityCode'] = this.cityCode
this.params['planStartDate'] = this.playData
sessionStorage.setItem('historyData', JSON.stringify(this.params))
this.$router.push({path: '/travel-preference'})
}
},

getCityName(data) {
this.cityName = data[0]
this.cityCode = data[1]
this.layerShow = false
},
selfDriving() {
this.$router.push({path: '/data-compute'})
},
creatTrip: function () {
const that = this
let modifyCode = that.params.startCityCode.slice(0, 2)
if (that.modifyWay == 1 && modifyCode !== 63) {
that.defaultWay = true
that.params['transportType'] = 0
that.params['startCityName'] = that.cityName
that.params['startCityCode'] = that.cityCode
that.params['endCityName'] = that.cityName
that.params['endCityCode'] = that.cityCode
that.params['planStartDate'] = that.playData
sessionStorage.setItem('historyData', JSON.stringify(that.params))
setTimeout(function () {
that.selfDriving()
}, 1500);
if(that.params.createId && that.params.createId !== bus.userInfo.user.id){
this.$http.get("api/wtcp-recommend/public/travelPlan/app/reference?id=" + that.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
} else {
that.params['startCityName'] = that.cityName
that.params['startCityCode'] = that.cityCode
that.params['endCityName'] = that.cityName
that.params['endCityCode'] = that.cityCode
that.params['planStartDate'] = that.playData
sessionStorage.setItem('historyData', JSON.stringify(that.params))
that.selfDriving()
if(that.params.createId && that.params.createId !== bus.userInfo.user.id){
this.$http.get("api/wtcp-recommend/public/travelPlan/app/reference?id=" + that.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
}
},
toOutline(index) {
this.$router.push({path: '/travel-profile/' + this.recomList[index].id})
},
randomArr(maxcount) {
let arr = [];
for (let i = 0; i < maxcount; i++) {
arr.push(i)
}
return arr;
},
RandomNumBoth(arr, maxNum) {
let numArr = [];

let arrLength = arr.length;
for (let i = 0; i < arrLength; i++) {


let number = Math.floor(Math.random() * arr.length); 

numArr.push(arr[number]);

arr.splice(number, 1);
if (arr.length <= maxNum) {
return numArr;
}
}
}
}
}
